// extracted by mini-css-extract-plugin
export var boxItems = "_7k-1";
export var boxItemsLg = "_7k-2";
export var button = "_7k-7";
export var buttonHoverless = "_7k-9";
export var buttonLg = "_7k-8";
export var filterGroupBox = "_7k-0";
export var icon = "_7k-3";
export var iconSecondary = "_7k-6";
export var iconWrapper = "_7k-4";
export var iconWrapperLg = "_7k-5";
export var truncatedLabel = "_7k-a";